import { mixins, styled } from '@bob/library'

export const SwimlanesContainer = styled.div`
  ${mixins.media.min.desktop} {
    display: none;
  }
`

export const ProductWrapper = styled.div`
  ${mixins.media.min.tablet} {
    width: 100%;
  }

  ${mixins.media.max.phone} {
    margin: 0 auto;
    width: 100%;
  }
`
